<template>
  <div
    :id="`map_${name}`"
    class="map" />
</template>

<script>
import Vue from 'vue'
import L from 'mapbox.js'
import router from '../router/index'
import {mapboxSetup} from '../constants'
import BuildingStockPopup from '../components/BuildingStockPopup'
import ValuesDisplayMixin from '../mixins/ValuesDisplayMixin'

export default {
  name: 'BuildingStockMap',
  mixins: [ValuesDisplayMixin],
  data () {
    return {
      map: null,
      markers: [],
      markersLayer: L.featureGroup(),
      bounds: null,
      tiles: mapboxSetup,
      shonBounds: {
        min: null,
        max: null
      },
      costBounds: {
        min: null,
        max: null
      }
    }
  },
  mounted: function () {
    let app = this
    app.initMap()
  },
  props: {
    name: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    getRadius: {
      type: Function,
      required: true
    },
    getColor: {
      type: Function,
      required: true
    }
  },
  methods: {
    initMap: function () {
      let app = this
      L.mapbox.accessToken = app.tiles.accessToken
      app.map = L.mapbox.map(
        `map_${app.name}`,
        undefined, {
          scrollWheelZoom: false
        }
      )
      L.mapbox.styleLayer(app.tiles.style).addTo(app.map)
      app.map.zoomControl.setPosition('bottomright')
      app.drawMarkers()
    },
    drawMarkers: function () {
      let app = this
      app.markers = []
      app.markersLayer.clearLayers()
      app.processSHONBounds()
      app.processCostBounds()

      for (let i = 0; i < app.data.length; i++) {
        let item = app.data[i]
        let marker = L.circleMarker([item.place_details.location.latitude, item.place_details.location.longitude], {
          radius: app.getRadius(item, app.shonBounds),
          color: '#fff',
          weight: 2,
          fillColor: app.getColor(item, app.costBounds),
          fillOpacity: 1
        }).addTo(app.map)
        marker.item = item
        marker.on('click', event => {
          app.showPopup(marker)
        })
        app.markers.push(marker)
        app.markersLayer.addLayer(marker)
      }

      app.markersLayer.addTo(app.map)
      app.map.fitBounds(app.markersLayer.getBounds())
    },
    showPopup: function (marker) {
      let app = this
      let content = this.getPopupContent(marker.item)
      let popup = L.popup()
        .setLatLng([marker.item.place_details.location.latitude, marker.item.place_details.location.longitude])
        .setContent(content)
        .openOn(app.map)
      marker.popup = popup
    },
    getPopupContent: function (item) {
      let app = this
      let popup = BuildingStockPopup
      popup['router'] = router
      let Popup = Vue.extend(popup)
      let instance = new Popup({
        propsData: {
          popupData: {
            title: app.placeChoiceName(item.place_details),
            place: {
              id: item.place_details.parent,
              locality: item.place_details.locality,
              function: item.place_details.function,
              ownershipStatus: item.place_details.ownership_status
            },
            shon: item.shon,
            nbAreas: item.nb_areas,
            year: item.year,
            primaryEnergyConsumption: item.primary_energy_consumption,
            totalCost: item.total_cost
          }
        }
      })

      instance.$mount()
      return instance.$el.innerHTML
    },
    processSHONBounds: function () {
      let app = this
      let shonArray = app.data.map(x => x.shon)
      app.shonBounds.min = Math.min(...shonArray)
      app.shonBounds.max = Math.max(...shonArray)
    },
    processCostBounds: function () {
      let app = this
      let costArray = app.data.map(x => x.total_cost)
      app.costBounds.min = Math.min(...costArray)
      app.costBounds.max = Math.max(...costArray)
    }
  },
  watch: {
    data: function () {
      this.drawMarkers()
    }
  }
}
</script>

<style lang="scss">
@import "mapbox.js/theme/style.css";

.map {
  height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/BuildingStockMap.vue